import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import MediaPickerLoadMoreCard from '../../../common/MediaPickerLoadMoreCard';
import MediaPickersConstants from '../../../MediaPickersConstants';

const ImageElementStockImagesLoadMoreCard = (props) => {
    const {
        setProperty, imageElementStockImagesOrientation, searchImageElementStockImages, imageElementStockImagesSearchValue,
        imageElementStockImagesDefaultKeyword, imageElementStockImagesLoading,
        galleryCardWidth, galleryCardHeight, imageElementStockImagesPageNumber
    } = props;

    const onLoadMoreButtonClick = () => {
        setProperty('imageElementStockImagesLoading', true);
        const keyword = imageElementStockImagesSearchValue || imageElementStockImagesDefaultKeyword;
        searchImageElementStockImages(keyword, imageElementStockImagesOrientation, imageElementStockImagesPageNumber + 1, MediaPickersConstants.STOCK_IMAGES_PER_PAGE, () => {
            setProperty('imageElementStockImagesLoading', false);
        });
    };

    return (
        <MediaPickerLoadMoreCard
            key={'load-more-button'}
            onLoadMoreButtonClick={onLoadMoreButtonClick}
            isLoading={imageElementStockImagesLoading}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        imageElementStockImagesSearchValue,
        imageStockImagesSearchValue,
        imageElementStockImagesDefaultKeyword,
        imageStockImagesDefaultKeyword,
        imageElementStockImagesLoading,
        imageStockImagesLoading,
        imageElementStockImagesPageNumber,
        imageStockImagesPageNumber,
        imageElementStockImagesOrientation,
        imageStockImagesOrientation
    } = state.mediaPicker;

    return {
        imageElementStockImagesOrientation: imageElementStockImagesOrientation ?? imageStockImagesOrientation,
        imageElementStockImagesSearchValue: imageElementStockImagesSearchValue ?? imageStockImagesSearchValue ?? '',
        imageElementStockImagesDefaultKeyword: imageElementStockImagesDefaultKeyword ?? imageStockImagesDefaultKeyword,
        imageElementStockImagesLoading: imageElementStockImagesLoading ?? imageStockImagesLoading ?? false,
        imageElementStockImagesPageNumber: imageElementStockImagesPageNumber ?? imageStockImagesPageNumber ?? 1
    };
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const searchImageElementStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback) =>
        dispatch(mediaPickerActions.searchImageElementStockImages(keywords, orientation, pageNumber, itemsPerPage, callback));

    return {
        setProperty,
        searchImageElementStockImages
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementStockImagesLoadMoreCard);
